export default __webpack_public_path__ + "static/media/fan_3.301cdcb9.svg";